<template>
  <span
    :class="{
      'block text-left': left,
      'block text-right': right,
    }"
  >
    <slot></slot>
  </span>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    left?: boolean;
    right?: boolean;
  }>(),
  {
    left: false,
    right: false,
  }
);
</script>
